import React, { memo } from 'react';
import { RequestProvider } from '@shootsta/common-react';
import SplashPage from '../components/SplashPage';
import { getSplashPageApi, createAnalyticsEntryApi, getPublicAssetApi } from '../../../api';

import { getVisitorId, getSessionId } from '../../ShareablePage/utils';

import { GraphqlResponse } from '../../../types';

interface Requests {
  // eslint-disable-next-line react/no-unused-prop-types
  getSplashPage: (id?: string) => Promise<GraphqlResponse>;
  // eslint-disable-next-line react/no-unused-prop-types
  getPublicAsset: (assetId: string) => Promise<GraphqlResponse>;
  // eslint-disable-next-line react/no-unused-prop-types
  createAnalyticsEntry: (
    id: string,
    visitorId?: string,
    sessionId?: string
  ) => Promise<GraphqlResponse>;
}

interface ShareablePageProps {
  id: string
}

function SplashPageContainer({ id }: ShareablePageProps) {
  return (
    <RequestProvider
      requests={{
        getSplashPage: getSplashPageApi(id),
        createAnalyticsEntry: createAnalyticsEntryApi(
          id,
          getVisitorId(),
          getSessionId()
        ),
        getPublicAsset: getPublicAssetApi()
      }}
    >
      {({
        getPublicAsset,
        createAnalyticsEntry,
        getSplashPage
      }: Requests) => (
        <SplashPage
          getSplashPage={getSplashPage}
          createAnalyticsEntry={createAnalyticsEntry}
          splashPageId={id}
          getPublicAsset={getPublicAsset}
        />
      )}
    </RequestProvider>
  );
}

export default memo(SplashPageContainer);
